import { mapGetters, mapActions } from 'vuex';
import { Slide } from 'vue-burger-menu'

export default {

  components: {Slide},

  data() {
    return {
      windowWidth: window.innerWidth,

    };
  },

  computed: {

    ...mapGetters([
      'auth',
    ]),

  },

  methods: {
    ...mapActions([
      'disconnectAccess',
      'getUser',
      'getPermissions'
    ]),

    seDeconnecter() {
      this.disconnectAccess().then(response => {
        this.$router.push('/se-connecter')
      }).catch(error => {

      });
    },

  },

  watch: {

  },

  beforeMount() {
    this.getUser().then(response => {
      this.getPermissions().then(response => {

      }).catch(error => {

      });
    }).catch(error => {

    });
  },

  mounted() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth
    }
  },

};
